<template>
  <div class="login-config-page">
    <div class="page-header">
      <div class="header-title-wrap">
        <h3 class="page-title">Cấu hình trang đăng nhập</h3>
        <p class="page-subtitle">Quản lý danh sách cấu hình hiển thị ảnh video trên trang đăng nhập</p>
      </div>
      <el-button
          class="btn-add"
          type="success"
          icon="el-icon-plus"
          @click="openCreateDialog"
      >Thêm mới</el-button>
    </div>

    <!-- Bộ lọc tự động -->
    <div class="search-area">
      <el-select
          v-model="searchParams.isActive"
          placeholder="Tất cả trạng thái"
          class="status-filter"
          @change="handleStatusFilterChange"
      >
        <el-option label="Đang hoạt động" :value="true"/>
        <el-option label="Ngừng hoạt động" :value="false"/>
      </el-select>
    </div>

    <!-- Bảng dữ liệu -->
    <div class="table-content row-data">
      <el-table
          v-loading="loadingData"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0)"
          :data="tableData"
          highlight-current-row
          :header-cell-style="tableHeaderColor"
          :max-height="$tableMaxHeight"
          :empty-text="textTable"
          border
          style="width: 100%"
      >
        <el-table-column type="index" label="STT" width="55" align="center"/>

        <el-table-column prop="configKey" label="Config Key" width="200"/>

        <el-table-column prop="groupName" label="Nhóm" width="200" align="center"/>

        <el-table-column prop="mediaType" label="Loại media" width="110" align="center">
          <template v-slot:default="scope">
            <el-tag :type="mediaTypeTagType(scope.row.mediaType)" size="small">
              {{ scope.row.mediaType }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="configValue" label="Giá trị" min-width="220" show-overflow-tooltip/>

        <el-table-column
            prop="orderPriority"
            label="Thứ tự"
            width="90"
            align="center"
            sortable
            :sort-method="sortByOrderPriority"
        />

        <el-table-column label="Trạng thái" width="130" align="center">
          <template v-slot:default="scope">
            <el-tag :type="scope.row.active ? 'success' : 'danger'" size="small">
              {{ scope.row.active ? 'Hoạt động' : 'Ngừng' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="Tác vụ" align="center" fixed="right" width="200">
          <template v-slot:default="scope">
            <el-button
                size="mini"
                type="success"
                icon="el-icon-edit"
                @click="openUpdateDialog(scope.row)"
            >Sửa</el-button>
            <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
            >Xóa</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- Phân trang -->
    <div class="pagination-wrap">
      <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="totalItems"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchParams.limit"
          :current-page="searchParams.page"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
      />
    </div>

    <!-- Dialog tạo mới -->
    <CreateLoginConfigDialog
        :visible="isCreateVisible"
        @close="handleCloseCreate"
    />

    <!-- Dialog chỉnh sửa -->
    <UpdateLoginConfigDialog
        :visible="isUpdateVisible"
        :item="selectedItem"
        @close="handleCloseUpdate"
    />
  </div>
</template>

<script>
import LoginConfigService from "@/services/AdminService/LoginConfigService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import CreateLoginConfigDialog from "@/views/master/data/CreateLoginConfigDialog.vue";
import UpdateLoginConfigDialog from "@/views/master/data/UpdateLoginConfigDialog.vue";

export default {
  name: "LoginConfig",
  components: {CreateLoginConfigDialog, UpdateLoginConfigDialog},
  data() {
    return {
      textTable: this.$tableEmpty,
      loadingData: false,
      tableData: [],
      totalItems: 0,
      searchParams: {
        isActive: true,
        page: 1,
        limit: 20,
      },
      isCreateVisible: false,
      isUpdateVisible: false,
      selectedItem: null,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7; color: #fff; font-weight: bold";
    },

    mediaTypeTagType(type) {
      const map = {IMAGE: 'primary', VIDEO: 'success', YOUTUBE: 'danger', TEXT: '', LINK: 'warning'};
      return map[type] || 'info';
    },

    sortByOrderPriority(a, b) {
      return Number(a.orderPriority || 0) - Number(b.orderPriority || 0);
    },

    async fetchData() {
      this.loadingData = true;
      try {
        const {isActive, page, limit} = this.searchParams;
        const res = await LoginConfigService.search(
            null,
            null,
            null,
            isActive === '' ? null : isActive,
            page,
            limit
        );
        const result = res.data.data;
        this.tableData = result.data || [];
        this.totalItems = result.total || 0;
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingData = false;
      }
    },

    handleStatusFilterChange() {
      this.searchParams.page = 1;
      this.fetchData();
    },

    handlePageChange(page) {
      this.searchParams.page = page;
      this.fetchData();
    },

    handleSizeChange(size) {
      this.searchParams.limit = size;
      this.searchParams.page = 1;
      this.fetchData();
    },

    openCreateDialog() {
      this.isCreateVisible = true;
    },

    handleCloseCreate(needReload) {
      this.isCreateVisible = false;
      if (needReload) this.fetchData();
    },

    openUpdateDialog(row) {
      this.selectedItem = {...row};
      this.isUpdateVisible = true;
    },

    handleCloseUpdate(needReload) {
      this.isUpdateVisible = false;
      this.selectedItem = null;
      if (needReload) this.fetchData();
    },

    handleDelete(row) {
      this.$confirm(
          `Bạn có chắc chắn muốn xóa cấu hình "${row.configKey}"?`,
          "Xác nhận xóa",
          {
            confirmButtonText: "Xóa",
            cancelButtonText: "Hủy",
            type: "warning",
            closeOnClickModal: false,
          }
      ).then(() => {
        LoginConfigService.delete(row.id).then((res) => {
          if (res.data.data) {
            NotifyMessage.leftCornerNotificationSuccess("Xóa cấu hình thành công");
            this.fetchData();
          } else {
            NotifyMessage.leftCornerNotificationError("Xóa cấu hình thất bại");
          }
        }).catch((err) => {
          NotifyMessage.leftCornerNotificationError(err?.response?.data?.message || "Lỗi kết nối");
        });
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.login-config-page {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.header-title-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.page-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
}

.page-subtitle {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.search-area {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.filter-label {
  font-weight: 600;
  color: #334155;
}

.status-filter {
  width: 200px;
}

.filter-hint {
  font-size: 12px;
  color: #64748b;
}

.btn-add {
  border-radius: 10px;
  min-width: 120px;
}

.table-content {
  margin-bottom: 14px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 2px;
}

/deep/ .el-table th {
  font-size: 13px;
}

/deep/ .el-table .cell {
  line-height: 1.45;
}

@media (max-width: 768px) {
  .status-filter {
    width: 100%;
  }
}
</style>
